// extracted by mini-css-extract-plugin
module.exports = {"heroMain":"styles_heroMain__IjBqB","buttonWrapper":"styles_buttonWrapper__SutuE","spinner":"styles_spinner__3Md_a"};